import React from 'react';
import { Progress} from '@Comp';

const ProgressBar = ({progressBar = 0,isEditable = true ,isViewable, businessProfile}) => {//NOSONAR
    return (
        <div className="view-header business-profile-header">
        <header className="title text-white">
    <h1 className="h4 text-uppercase mb-2">{isViewable && `${businessProfile && businessProfile.businessName}'s`} Business Profile</h1>
    <p className="mb-0">{isViewable && `${businessProfile && businessProfile.id}`}</p>
    <p className="mb-0">{isViewable && `${businessProfile && businessProfile.businessEmail}`}</p>
    {!isViewable && <>
            {
    !isEditable && <p className='text-warning mb-2'>(Your profile is being verified)</p>
    }
    {isEditable && <p className="mb-2">Complete Business Profile</p>}
            <div className="profileProgress fifth-step eleventh-step">
                <div className="text-center small mb-2">Business Profile Progress</div>

                <Progress multi className="mb-0 pbar business-profile-progress">
                    <Progress bar value={progressBar} style={{backgroundColor: '#E6B23A'}}>
                        <h6 style={{color: '#050259', fontWeight: 'bold'}}>{progressBar} % Complete</h6>
                    </Progress>
                </Progress>
            </div>
            </>
}
        </header>
    </div>
    );
};

export default ProgressBar;
